import {ofetch, FetchOptions, MappedResponseType} from 'ofetch';
import {ref} from 'vue';

export function useOfetch() {
    const isFinished = ref(false);
    const isFetching = ref(false);

    /**
     * @param {string} url
     * @param {FetchOptions} options
     * @returns {Promise<MappedResponseType<"json", any>>}
     */
    async function execute(url, options) {
        isFetching.value = true;
        try {
            return await ofetch(url, options);
        } catch (error) {
            throw error;
        } finally {
            isFetching.value = false;
            isFinished.value = true;
        }
    }

    return {
        isFinished,
        isFetching,
        execute,
    };
}
